export default __webpack_public_path__ + "static/media/26.74f73e5e.png";